__turbopack_context__.v({
  "icon": "_2llbfW_icon",
});
